import {
  AdvancedMarker,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import { Marker as ClusterMarker } from "@googlemaps/markerclusterer";
import { CommercialPin } from "./CommercialPin";
import { useEffect, useState } from "react";

const getPinColor = (priceDrop: number) => {
  switch (priceDrop) {
    case 0:
      return "#E0E0E0";
    case 1:
      return " #B0D9F0";
    case 2:
      return "#A3D9A1";
    case 3:
      return " #F5C6C6";
    case 4:
      return "#F4B942";
    default:
      return "#F4B942";
  }
};

export const CommercialMarker = ({
  listing,
  onClick,
  setMarkerRef,
}: {
  listing: any;
  onClick: (itm: any, e: any) => void;
  setMarkerRef: (marker: ClusterMarker | null, key: string) => void;
}) => {
  const [clickListener, setClickListener] =
    useState<google.maps.MapsEventListener | null>(null);
  const map = useMap();
  const markerLib = useMapsLibrary("marker");
  useEffect(() => {
    if (map && markerLib) {
      const pinBackground = new markerLib.PinElement({
        background: getPinColor(listing.price_drop),
      });
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
          lat: parseFloat(listing?.latitude || ""),
          lng: parseFloat(listing?.longitude || ""),
        },
        content: pinBackground.element,
        map,
      });

      setClickListener(
        google.maps.event.addListener(marker, "click", function (e: any) {
          onClick(listing, e);
        })
      );

      setMarkerRef(marker, listing.listing_unique_id);

      return () => {
        if (clickListener) {
          google.maps.event.removeListener(clickListener);
        }
        marker.map = null;
      };
    }
  }, []);
  return null;
};
